import React from 'react';
import styles from './SmallCards.module.css';
import { useTranslation } from 'react-i18next';

const SmallCards = ({ cards, ...props }) => {
  const { t } = useTranslation();

  return (
    <section className={styles.sectionCards}>
      <div className={styles.sectionCardsContainer}>
        {
          cards.map((card, index) => (
            <div key={index} className={styles.card}>
            <img src={card.image} alt={card.title}/>
            <h3>{card.title}</h3>
          </div>
        ))
      }
      </div>
    </section>
  );
};

export default SmallCards; 